export default __webpack_public_path__ + "static/media/soups-whatsapp-slides.efe6702c.pdf";